import React from 'react';

import Text2 from './text2'
import Boxservice from './categorias/boxservice'
import Boxservice2 from './categorias/boxservice2'
import Boxservice3 from './categorias/boxservice3'
import Boxservice4 from './categorias/boxservice4'
import Boxservice5 from './categorias/boxservice5'
import Boxservice6 from './categorias/boxservice6'
import Boxservice7 from './categorias/boxservice7'
import Boxservice8 from './categorias/boxservice8'
import Boxservice9 from './categorias/boxservice9'
import Boxservice10 from './categorias/boxservice10'
import Boxservice11 from './categorias/boxservice11'


import Grid from '@material-ui/core/Grid';

export default function SimpleContainer() {
  return (

    <React.Fragment>
      {/* <div style={{ marginTop: '-20px', height: '600px', backgroundColor: '#FAFAF8', width: 'auto' }}>

        <div component="div" style={{ marginTop: '-15px', backgroundImage: '#F2F2F2', height: '780px', width: 'auto' }}> */}

      <Grid  >

        <Grid container style={{ flexDirection: 'row', flexWrap: 'wrap', flex: 1, marginTop: '0px', backgroundColor: '#FAFAF8' }}
          spacing={3}
          justify="center"
        >
          <Grid item xs={12} style={{ marginBottom: 40 }}>
            <Text2 />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2} >
            <Boxservice />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2} >
            <Boxservice2 />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2} >
            <Boxservice3 />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2} >
            <Boxservice4 />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Boxservice5 />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Boxservice6 />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Boxservice7 />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Boxservice8 />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Boxservice9 />
          </Grid>

          <Grid item xs={6} sm={4} md={3} lg={2}>
            <Boxservice10 />
          </Grid>
        </Grid>
      </Grid>

      {/* </div>

      </div> */}

    </React.Fragment>
  );
}
